import { render, staticRenderFns } from "./SliderProducts.vue?vue&type=template&id=6a7453b9"
import script from "./SliderProducts.vue?vue&type=script&lang=js"
export * from "./SliderProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports